import _ from "lodash"
import React, { useState, useEffect } from "react"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
import increaseService from "data/increase"

const RentAdvanced = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.rentdetail"));
  const inflationOptions = _.map(props.namedItems['inflation'], (i) => { return {label: i.code, value: i.inflationid} })
  const increaseOptions = _.map(props.namedItems['increase'], (i) => { return {label: i.code, value: i.increaseid} })

  const emptyRecord = {
    newAmt: null,
    newAmtType: props.defaults["rentAmtType"],
    renewalAmt: null,
    renewalAmtType: props.defaults["rentAmtType"],
    inflation: {
      inflationMode: "namedItem",
      inflationNamedItemId: _.get(props, "defaults.rentInflation.inflationNamedItemId")
    },
    increaseNamedItemId: _.get(props, "defaults.rentIncrease.increaseNamedItemId", _.find(increaseService.value(), {code: '*None'})?.increaseid)
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'advanced') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)

    if(field === "inflationNamedItemId") {
      _.set(nextData, "inflation", {
        inflationMode: "namedItem",
        inflationNamedItemId: val
      })
    } else if(field === "newAmt" && !_.get(nextData, "renewalAmt")) {
          _.set(nextData, field, val)
          _.set(nextData, "renewalAmt", val)
    } else {
      _.set(nextData, field, val)
    }

    setData(nextData);
    props.persist({...nextData, state: 'advanced'}, 'rentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('marketlease', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
      <div>
          <label>New Amt</label>
          <NumberInput
            field="newAmt"
            className="automated"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}/>
        </div>
        <div>
          <label>New Amt Type</label>
          <DropdownInput
            field="newAmtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['rentAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
            persist={updateData}/>
        </div>
        <div>
          <label>Renewal Amt</label>
          <NumberInput
            field="renewalAmt"
            className="automated"
            data={data}
            attrs={attrs}
            min={0}
            max={1000000000000}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}/>
        </div>
        <div>
          <label>Renewal Amt Type</label>
          <DropdownInput
            field="renewalAmtType"
            className="automated"
            data={data}
            attrs={attrs}
            default={props.defaults['rentAmtType']}
            options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr', '% of Last Rent', '% of New Rent']}
            persist={updateData}/>
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput
            className="automated named-item-state-input"
            data={_.get(data, 'inflation')}
            default={_.get(props, "defaults.rentInflation.inflationNamedItemId")}
            attrs={attrs}
            field="inflationNamedItemId"
            filter={true}
            options={inflationOptions}
            persist={updateData}/>
        </div>
        <div>
          <label>Increase</label>
          <DropdownInput
            className="automated named-item-state-input"
            data={data}
            attrs={attrs}
            field="increaseNamedItemId"
            filter={true}
            options={increaseOptions}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default RentAdvanced
